import type { AuthContext } from '../router';

interface AuthenticatedBeforeLoadOptions {
  context: { auth: AuthContext };
  location: { href: string };
}

export async function authenticatedBeforeLoad({
  context,
  location,
}: AuthenticatedBeforeLoadOptions) {
  const resolved = await context.auth.whenReady();

  if (!resolved.isAuthenticated) {
    context.auth.login(location.href);
    // Keep the route pending while Auth0 replaces the page. Throwing this
    // Promise makes TanStack Router render its error component instead.
    return new Promise<never>(() => {});
  }

  return {
    auth: {
      ...context.auth,
      isAuthenticated: resolved.isAuthenticated,
      hasPermission: resolved.hasPermission,
    },
  };
}
